import * as React from 'react';

import { Text } from '@components/common';
import { default as Select, SelectOption, SelectProps } from '@components/common/Select';
import { Team2SVG, WorkspaceSVG } from '@components/svgs';

export const PERMISSION_CONDITION_OPTIONS: SelectOption<PermissionCondition>[] = [
  { value: 'unconditional_allow', label: 'All Members of the Workspace' },
  { value: 'allow_if_team_match', label: 'Admins, and all members of affiliated Team' }
];

type Props = Omit<SelectProps<PermissionCondition>, 'options'>;

const renderOption = (v: (typeof PERMISSION_CONDITION_OPTIONS)[0]) => (
  <div className='flex items-center space-x-2 truncate'>
    {v.value === 'unconditional_allow' && <WorkspaceSVG data-testid='workspace-svg' />}
    {v.value === 'allow_if_team_match' && <Team2SVG data-testid='team2-svg' />}
    <Text h='400' truncate>
      {v.label}
    </Text>
  </div>
);

export const DefaultPermissionConditionSelect: React.FC<React.PropsWithChildren<Props>> = ({ ...rest }) => (
  <Select<PermissionCondition>
    {...rest}
    options={PERMISSION_CONDITION_OPTIONS}
    renderSelected={renderOption}
    renderLabel={renderOption}
    wrapperClass='w-full max-w-md'
  />
);
